<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    @Component({
        components: {},
    })
    export default class ChartProgressInput extends Vue {
        progress = 0.2;
        displayData = 0;

        @Prop()
        data;
        @Prop()
        max;
        @Prop()
        min;

        changeProgressToInput() {
            this.displayData = this.min + Math.round(this.progress * (this.max - this.min));
            this.$emit("changeInput", this.displayData);
        }
        changeInputToProgress() {
            this.progress = (this.displayData - this.min) / (this.max - this.min);
        }
        progressBar = null;
        handleMousedown(e: MouseEvent) {
            let x = e.clientX;
            const maxLeft = (this.progressBar as HTMLElement).parentElement.clientWidth || 0;
            const nowLeft = e.offsetX;
            this.progress = Math.round((nowLeft / maxLeft) * 100) / 100;
            this.changeProgressToInput();
            document.onmousemove = (e) => {
                let tempLeft = nowLeft + e.clientX - x;
                tempLeft = tempLeft < 0 ? 0 : tempLeft > maxLeft ? maxLeft : tempLeft;
                this.progress = Math.round((tempLeft / maxLeft) * 100) / 100;
                this.changeProgressToInput();
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }
        handleInputChange() {
            this.changeInputToProgress();
            this.$emit("changeInput", this.displayData);
        }
        progressInput = null;
        handelKeypress(e: KeyboardEvent) {
            if (e.keyCode == 13) {
                this.progressInput.blur();
            }
        }

        mounted() {
            this.progressBar = this.$refs.progressBar;
            this.progressInput = this.$refs.progressInput;
            this.displayData = this.data;
            this.changeInputToProgress();
        }
    }
</script>

<template>
    <div class="progress-box">
        <div class="progress-bar" @mousedown="handleMousedown">
            <div ref="progressBar" class="progress-active" :style="{ width: `${progress * 100}%` }"></div>
        </div>
        <div class="progress-input">
            <input
                ref="progressInput"
                type="text"
                v-model="displayData"
                @blur="handleInputChange"
                @keypress="handelKeypress($event)"
                :max="max"
                :min="min"
            />
        </div>
    </div>
</template>

<style lang="stylus" scoped>
    .progress-box
        display flex
        width 100%
        height 20px
        .progress-bar
            width calc(100% - 40px)
            background rgba(255, 255, 255, 0.2)
            border-radius 4px
            overflow hidden
            cursor pointer
            .progress-active
                height 100%
                background var(--themeColor)
        .progress-input
            display flex
            justify-content center
            align-items center
            width 32px
            height 100%
            padding 4px 0
            margin-left 8px
            background rgba(255, 255, 255, 0.2)
            border-radius 4px
            input
                color #fff
                border none
                outline none
                margin 0
                width 80%
                background none
                text-align center
</style>
